export enum OnboardingStep {
  SELECT_AUDIENCE,
  SELECT_GOAL,
}
